export default {"src":"/_next/static/media/footer-curve.3130ba7f.svg","height":51,"width":430};